import { render, staticRenderFns } from "./dropdown-list.component.vue?vue&type=template&id=0aa5d152"
import script from "./dropdown-list.component.ts?vue&type=script&lang=ts&external"
export * from "./dropdown-list.component.ts?vue&type=script&lang=ts&external"
import style0 from "./dropdown-list.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports